import styled from 'styled-components';
import { Flex } from '../../layout/Flex';
import { UnavailableProductSnippetProps } from './typings';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'UnavailableProductSnippet' })
    .attrs<UnavailableProductSnippetProps>((props) => ({
        ...props,
        direction: 'row',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--control-secondary-background)',
        borderRadius: 3,
        p: props.p || 0.5,
        pr: props.pr || 1,
        spacing: 2,
    }))``;
